import { useEffect } from 'react';
import { useLocation } from 'react-router-dom';
import { blogPosts } from '../data/blogData';
import { locations } from '../data/locationData';

const locationSeoData = locations.reduce((acc, loc) => {
  acc[`/${loc.slug}`] = {
    title: loc.metaTitle,
    description: loc.metaDescription,
    keywords: loc.metaKeywords,
  };
  return acc;
}, {});

const SEO_DATA = {
  '/': {
    title: 'Trika Studio | Web Design & Development — Youngsville, NC',
    description: 'Raleigh-area web design & development. Fixed pricing from $1,200. Fast turnaround. You own everything. Serving Triangle, NC businesses. Call (919) 229-5525.',
    keywords: 'web development, web development company, web design, website development, web developer, Youngsville NC, Triangle NC, Raleigh Durham, website developer near me, small business website, custom web development, fixed price web development'
  },
  '/services': {
    title: 'Web Design & Development Services | Trika Studio NC',
    description: 'Professional web development, branding, and digital marketing for small businesses. Fixed pricing from $1,200. Based in Triangle, NC — serving clients nationwide.',
    keywords: 'web development services, branding services, AI tools, monthly website support, Triangle NC web developer, remote web developer, nationwide'
  },
  '/pricing': {
    title: 'Web Design Pricing Raleigh NC | Trika Studio',
    description: 'Web design pricing for Raleigh, NC businesses. Fixed packages from $1,200. No hourly billing, no hidden fees. Know exactly what you pay before we start.',
    keywords: 'web development pricing, fixed price website, affordable web design, website cost, affordable web developer'
  },
  '/work': {
    title: 'Portfolio & Case Studies | Trika Studio',
    description: 'Real projects built by Trika Studio — Triangle Crokinole Club, HRally, Buzzy Gardner Law. Delivering results for startups and small businesses in NC.',
    keywords: 'web development portfolio, website case studies, client projects, web design examples, startup websites'
  },
  '/about': {
    title: 'About Anushka | Trika Studio — NCAA Athlete & Developer',
    description: 'Meet Anushka — NCAA Division I athlete turned web developer with 10+ years of experience. Senior-level web development without the agency markup. Triangle, NC.',
    keywords: 'about Trika Studio, Anushka web developer, NCAA athlete developer, Triangle NC freelance developer, remote web developer'
  },
  '/contact': {
    title: 'Contact Trika Studio | Free Discovery Call',
    description: 'Book a free 30-min discovery call or send a message. Based in Triangle, NC — serving clients nationwide. Call (919) 229-5525.',
    keywords: 'contact web developer, hire web developer, free consultation, book discovery call, web development quote, remote web developer'
  },
  '/blog': {
    title: 'Blog | Trika Studio — Web Development & Business Tips',
    description: 'Practical advice on web development, design, and digital strategy for small businesses and startups. No fluff, no jargon — just honest guidance.',
    keywords: 'web development blog, small business website tips, web design advice, startup website guide, how much does a website cost'
  },
  '/privacy': {
    title: 'Privacy Policy | Trika Studio',
    description: 'Learn how Trika Studio collects, uses, and protects your personal information. GDPR and CCPA compliant privacy policy.',
    keywords: 'privacy policy, data protection, GDPR, CCPA, personal information, data privacy'
  },
  '/terms': {
    title: 'Terms of Service | Trika Studio',
    description: 'Read Trika Studio\'s terms of service. Clear, fair agreements for web design, development, and marketing projects. No confusing legal jargon.',
    keywords: 'terms of service, service agreement, terms and conditions, web development contract, legal terms'
  },
  '/digital-marketing': {
    title: 'Digital Marketing Services | Trika Studio NC',
    description: 'SEO, Google Ads, social media, and content marketing — managed by one expert. No agency overhead. Get more customers starting today.',
    keywords: 'digital marketing services, online marketing, small business marketing, digital marketing agency, SEO services, PPC management, social media marketing, content marketing'
  },
  '/seo': {
    title: 'SEO Services | Local & National SEO — Trika Studio',
    description: 'Rank higher on Google with proven SEO strategies. Local SEO, national SEO, technical SEO, and content optimization. Pricing from $500/mo.',
    keywords: 'SEO services, local SEO, national SEO, search engine optimization, Google ranking, small business SEO, SEO agency, SEO company, keyword ranking'
  },
  '/google-ads': {
    title: 'Google Ads Management | PPC Advertising — Trika Studio',
    description: 'Get leads today with Google Ads. Expert PPC management, landing page optimization, and transparent reporting. No long-term contracts. From $500/mo.',
    keywords: 'Google Ads management, PPC management, pay per click advertising, Google Ads agency, PPC agency, Google Ads for small business, SEM, search engine marketing'
  },
  '/social-media-marketing': {
    title: 'Social Media Marketing & Management | Trika Studio',
    description: 'Build your brand on social media. Content creation, scheduling, community management, and paid social campaigns. Plans starting at $750/mo.',
    keywords: 'social media marketing, social media management, Facebook marketing, Instagram marketing, LinkedIn marketing, social media agency, social media for small business'
  },
  '/content-marketing': {
    title: 'Content Marketing Services | Trika Studio NC',
    description: 'Attract customers with SEO blog posts, email campaigns, and lead magnets. Content marketing that ranks on Google and converts visitors to leads. From $800/mo.',
    keywords: 'content marketing services, blog writing services, SEO content, email marketing, lead magnets, content strategy, blog writing agency, content creation'
  },
  '/law-firm-marketing': {
    title: 'Law Firm Marketing | SEO & Websites for Lawyers',
    description: 'More clients for your law firm. SEO, Google Ads & content for attorneys. Own your website. Better than FindLaw. No long-term contracts.',
    keywords: 'law firm marketing, lawyer marketing, attorney marketing, SEO for lawyers, Google Ads for attorneys, law firm website, legal marketing, FindLaw alternative, lawyer SEO'
  },
  '/medical-practice-marketing': {
    title: 'Medical Practice Marketing | SEO for Doctors',
    description: 'Get more patients for your medical practice. HIPAA-aware SEO, Google Ads, and reputation management for doctors and healthcare providers.',
    keywords: 'medical practice marketing, healthcare marketing, doctor marketing, medical SEO, Google Ads for doctors, patient acquisition, medical website, healthcare SEO, dentist marketing'
  },
  '/construction-web-design': {
    title: 'Construction Web Design Raleigh NC | Trika Studio',
    description: 'Websites for construction companies in Raleigh, Morrisville & Apex, NC. Project galleries, service area pages & local SEO setup. From $1,500.',
    keywords: 'construction website design Raleigh, contractor web design, construction company website, builder website Raleigh NC, trades website design, contractor website, roofing website, plumber website, HVAC website, construction web design'
  },
  '/dental-web-design': {
    title: 'Dental Website Design Raleigh NC | Trika Studio',
    description: 'Professional dental websites in Raleigh, NC. Online booking, smile galleries, Google reviews & dental SEO. Own your site — no monthly fees. From $2,000.',
    keywords: 'dental website design Raleigh, dentist website, dental practice marketing, dental SEO, dentist near me, dental website cost, dental marketing Raleigh NC, cosmetic dentistry website, orthodontist website, pediatric dentist website'
  },
  '/review-request': {
    title: 'Leave a Google Review | Trika Studio',
    description: 'Had a great experience with Trika Studio? Leave a Google review and help other local businesses find a web designer they can trust.',
    keywords: 'Trika Studio reviews, leave a review, Google review link, Trika Studio Youngsville reviews'
  },
  '/home-services': {
    title: 'Home Services Web Design | Trika Studio NC',
    description: 'Websites for roofing, plumbing, HVAC, electrical & landscaping businesses that convert local searches into booked jobs. Mobile-first, local SEO built-in.',
    keywords: 'home services web design, contractor websites, trades website design, roofing web design, plumber web design, hvac web design, electrician website, landscaping website'
  },
  '/roofing-web-design': {
    title: 'Roofing Company Web Design Raleigh NC | Trika Studio',
    description: 'High-converting roofing websites with service area pages, project galleries & review integration. Local SEO for Raleigh, Wake Forest, Youngsville & Durham.',
    keywords: 'roofing website design Raleigh, roofer web design, roofing SEO, roofing contractor website, roof repair website, roofing company website'
  },
  '/plumber-web-design': {
    title: 'Plumber Web Design Raleigh NC | Trika Studio',
    description: 'Websites for plumbing companies that turn emergency searches into calls. Service area pages, plumber SEO, reviews, and mobile-first performance.',
    keywords: 'plumber web design Raleigh, plumbing website, emergency plumber website, plumber SEO, plumber near me website'
  },
  '/hvac-web-design': {
    title: 'HVAC Web Design Raleigh NC | Trika Studio',
    description: 'Fast, mobile-first HVAC websites that convert AC/heat emergencies into booked service calls. Promotions, plans, reviews, and city pages included.',
    keywords: 'hvac web design Raleigh, ac repair website, hvac company website, hvac seo, heating and cooling website'
  },
  '/electrician-web-design': {
    title: 'Electrician Web Design Raleigh NC | Trika Studio',
    description: 'Websites for electricians that drive calls and quotes. Service area pages, reviews, and local SEO for Raleigh, Wake Forest, Youngsville & Durham.',
    keywords: 'electrician web design Raleigh, electrical contractor website, ev charger install website, electrician seo'
  },
  '/landscaping-web-design': {
    title: 'Landscaping Web Design Raleigh NC | Trika Studio',
    description: 'Websites for landscapers and hardscapers that convert visitors to booked estimates. Portfolios, city pages, reviews, and landscaping SEO built-in.',
    keywords: 'landscaping web design Raleigh, lawn care website, hardscaping website, landscaping seo, landscape company website'
  },
  '/restaurant-web-design': {
    title: 'Restaurant Web Design Raleigh NC | Trika Studio',
    description: 'Websites for restaurants, cafes & food businesses in Raleigh, NC. Online menus, reservations, ordering, and local SEO. Own your site. From $1,500.',
    keywords: 'restaurant web design Raleigh, restaurant website, cafe website, food business website, restaurant SEO, online menu website, restaurant marketing Raleigh NC'
  },
  '/real-estate-web-design': {
    title: 'Real Estate Web Design Raleigh NC | Trika Studio',
    description: 'Websites for real estate agents and brokers in Raleigh, NC. IDX/MLS listings, lead capture, local SEO & Google Ads. Own your site. From $2,000.',
    keywords: 'real estate web design Raleigh, realtor website, real estate agent website, IDX website, MLS listings website, real estate SEO Raleigh, realtor marketing NC'
  },
  '/nonprofit-web-design': {
    title: 'Nonprofit Web Design Raleigh NC | Trika Studio',
    description: 'Affordable websites for nonprofits and charities in Raleigh, NC. Donation forms, volunteer sign-ups, event calendars & grant-ready design. From $1,200.',
    keywords: 'nonprofit web design Raleigh, charity website, nonprofit website, donation website, volunteer website, nonprofit marketing NC, 501c3 website design'
  }
};

export const SEO = () => {
  const location = useLocation();

  useEffect(() => {
    const path = location.pathname;
    
    // Check if this is a blog post page
    let seo;
    if (path.startsWith('/blog/')) {
      const slug = path.replace('/blog/', '');
      const post = blogPosts.find(p => p.slug === slug);
      if (post) {
        seo = {
          title: `${post.title} | Trika Studio Blog`,
          description: post.metaDescription,
          keywords: post.metaKeywords
        };
      } else {
        seo = SEO_DATA['/blog'] || SEO_DATA['/'];
      }
    } else {
      seo = SEO_DATA[path] || locationSeoData[path] || SEO_DATA['/'];
    }

    document.title = seo.title;

    const updateMeta = (name, content, isProperty = false) => {
      const attr = isProperty ? 'property' : 'name';
      let meta = document.querySelector(`meta[${attr}="${name}"]`);
      if (meta) {
        meta.setAttribute('content', content);
      } else {
        meta = document.createElement('meta');
        meta.setAttribute(attr, name);
        meta.setAttribute('content', content);
        document.head.appendChild(meta);
      }
    };

    updateMeta('description', seo.description);
    updateMeta('keywords', seo.keywords);

    updateMeta('og:title', seo.title, true);
    updateMeta('og:description', seo.description, true);
    updateMeta('og:url', `https://trikastudio.com${path}`, true);

    updateMeta('twitter:title', seo.title);
    updateMeta('twitter:description', seo.description);
    updateMeta('twitter:url', `https://trikastudio.com${path}`);

    let canonical = document.querySelector('link[rel="canonical"]');
    if (!canonical) {
      canonical = document.createElement('link');
      canonical.setAttribute('rel', 'canonical');
      document.head.appendChild(canonical);
    }
    canonical.setAttribute('href', `https://trikastudio.com${path === '/' ? '/' : path}`);

    // Track page view in GA4
    if (window.gtag) {
      window.gtag('event', 'page_view', {
        page_title: seo.title,
        page_location: window.location.href,
        page_path: path
      });
    }
  }, [location]);

  return null;
};
